import { ReactElement } from 'react';
import { AddressResource } from '@provider-directory/types/common.contracts';

export const highlightSubstring = (
  text: string,
  substring: string,
  className: string,
): (string | ReactElement)[] => {
  const substringParts = substring.split(' ').join('|');
  const substringPartsArray = substring
    .split(' ')
    .map((s) => s.toLocaleLowerCase());
  try {
    const parts = (text || '').split(new RegExp(`(${substringParts})`, 'gi'));
    return parts.map((part, index) =>
      substringPartsArray.includes(part.toLowerCase()) ? (
        <span key={index} className={className}>
          {part}
        </span>
      ) : (
        part
      ),
    );
  } catch {
    return [text];
  }
};

export interface CreateLocationLabelOptions {
  newlineForStreet2?: boolean;
}

export const createLocationLabel = (
  locationData: AddressResource,
  options?: CreateLocationLabelOptions,
): string => {
  const { street, street2, city, state, stateCode, zip } = locationData;
  const zipClean = zip.replace(/-/g, '\u2011');

  if (options?.newlineForStreet2 && street2) {
    return `${street}\n${street2}\n${city}, ${stateCode || state} ${zipClean}`;
  }

  const streetLine = street2 ? `${street}, ${street2},` : `${street},`;

  return `${streetLine} ${city}, ${stateCode || state} ${zipClean}`;
};

export const getIndefiniteArticle = (word: string): 'a' | 'an' => {
  if (!word) {
    return 'a';
  }
  return /^[aeiou]/i.test(word) ? 'an' : 'a';
};

export const titleCaseFromSlug = (slug: string): string =>
  slug.replace(
    /(^|-)([a-z])/g,
    (_, sep: string, c: string) => (sep ? ' ' : '') + c.toUpperCase(),
  );
